export default () =>({
   loading:false,
   error:false,
   exports:{},
   certificates:{},
   aboutCompany:{},
   aboutCompanyBanner:{},
   management:{},
   contactUsForm:{},
   countries:{},
   about_us_text:{}
});